import * as React from "react";
const SvgCross = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1l14 14m0-14L1 15", stroke: "currentColor", strokeWidth: 2 }));
export default SvgCross;
